import React,{Component} from "react";
// import { withRouter } from 'react-router';
// import Modal from "react-bootstrap/Modal";
import Wrp from "../../hoc/Wrp/Wrp";
// import { callGET } from '../../Utils/ApiUtil';
// import * as ShipConstants from '../../Global/Constants';
// import { getUserInfo } from '../../Utils/UserFunctions';
// import Buttons from '../../Components/UI/Buttons';

const currDate = new Date().toLocaleDateString();
const currTime = new Date().toLocaleTimeString()
const ErrorDetails = (props) => {
	let isOpen = props.showErrorDetails;
	const {errorsDetailList} = props
	const {infoErrorList,errorErrorList,warningErrorList,infoErrorListCount,errorErrorListCount,warningErrorListCount} = errorsDetailList
	return (
		<Wrp>
			
			<>
			{
					(isOpen===true)?
		            <div className="quick-sidebar-overlay" style={{"zIndex":1199}}></div>
		        	:<div></div>
		    	}
	    	<div className={(isOpen===true)?"quick_sidebar_open viewMoreTemp messagesInfo":"viewMoreTemp messagesInfo"} style={{"zIndex":1200}}>
	    		
		    	<div className="actionToggler quick-sidebar p-0 bg-white" >
	                {/* <a className="close-quick-sidebar cursor-pointer" style={{"top":"0","right":"10px","zIndex":"1"}} onClick={props.showErrorDetailsHandler}>
						<i className="fas fa-times fa-lg"></i>
					</a> */}
	                <div className="view view-xl">

	                	<ul className="tabPositions nav flex-column nav-pills nav-secondary nav-pills-no-bd nav-pills-icons  " id="pills-tab-with-icon" role="tablist">
					         <li className="nav-item">
					            <a className="nav-link messageInfo active p-2" data-toggle="pill" href="#msgInfo" role="tab">
					               <i className="fa fa-info-circle"></i>
					               <p className="mb-0"> {infoErrorListCount} Info </p>
					            </a>
					         </li>
					         <li className="nav-item">
					            <a className="nav-link messageWarning p-2" data-toggle="pill" href="#msgWarning" role="tab">
					               <i className="fas fa-exclamation-triangle"></i>
					               <p className="mb-0"> {warningErrorListCount}  Warnings </p>
					            </a>
					         </li>
					         <li className="nav-item">
					            <a className="nav-link messageError p-2" data-toggle="pill" href="#msgDanger" role="tab">
					               <i className="fa fa-times-circle"></i>
					               <p className="mb-0"> {errorErrorListCount} Errors </p>
					            </a>
					         </li>
					    </ul>

					    <div className="table_Box dataTables_wrapper">
					    	<div className="modal-header p-0 justify-content-center"></div>
					    	<div className="table_Body">
					    		<div className="tab-content" id="messageConfigBox">
					    			<div className="tab-pane fade show active" id="msgInfo" role="tabpanel" aria-labelledby="pills-home-tab-icon">
					    				{/* <table className="table">
					    				<thead>
				                           <tr>
				                              <th scope="col">#</th> 
				                              <th scope="col"> Result </th> 
				                           </tr>
				                        </thead>
				                        <tbody>
					    				{
											infoErrorListCount>0?
											infoErrorList.map((item,ind)=>{
												return(
													<tr>
						                              <td>{ind}</td> 
						                              <td className="text-info" style={{whiteSpace:'break-spaces'}}>{item.message}</td> 
						                           </tr>
												)	
											})												
											:
											<tr>
												<td colSpan="2">
													<div className="card">
														<div className="card-header p-2">
															<div className="card-title text-default"> No Info Message </div>
														</div>	
													</div>
												</td>
											</tr>
										}
										</tbody>
										</table>	 */}

										<ul className="timeline animated fadeIn">
											<li className="timeline-inverted">
												<div className="timeline-badge active">  <i className="fa fa-info-circle"></i> </div>
																	
												<div className="timeline-body">
												

													<div className="timeline-body">
														<div className="detailCard_Box mb-0">
														
															<div className="detailCard_Header sectionHeader">
																<h6 className="mb-0 text-muted fw-normal"> <span className="feed-item feed-item-info "> </span> Info <span className="text-muted"> -  {currDate}, {currTime} </span> </h6>
															</div>
															{
															infoErrorListCount>0?
															infoErrorList.map((item,ind)=>{
																return(
															<div className="detailCard_Body collapse show" id="item_2">
																<div className="table_Box dataTables_wrapper">
																	<div className="form-group d-flex align-items-center">
																		<label className="mb-0 fw-bold text-medium"> type : </label> 
																		<span className="w-100 text-truncate  pl-1 text-muted"> "Info" </span> 
																	</div> 
																	

																</div> 

																<div className="card mb-0 shadow-none">
																	<div className="card-body">
																		message: <span className="text-info pl-1"> {item.message} </span>
																	</div>
																</div>
															</div>
																)	
															})												
															:
															<div className="detailCard_Body collapse show" id="item_2">
																No Info Message
															</div>
														}
														</div>
													
													</div>
												</div>
											
											</li>
										</ul>				                   
					                </div>
					                <div className="tab-pane fade" id="msgWarning" role="tabpanel" aria-labelledby="pills-home-tab-icon">
					    				{/* <table className="table">
					    				<thead>
				                           <tr>
				                              <th scope="col">#</th> 
				                              <th scope="col"> Result </th> 
				                           </tr>
				                        </thead>
				                        <tbody>
					    				{
											warningErrorListCount>0?
											warningErrorList.map((item,ind)=>{
												return(
													<tr>
						                              <td>{ind}</td> 
						                              <td className="text-info">{item.message}</td> 
						                           </tr>
												)	
											})												
											:
											<tr>
												<td colSpan="2">
													<div className="card">
														<div className="card-header p-2">
															<div className="card-title text-default"> No Warning Message </div>
														</div>	
													</div>
												</td>
											</tr>
										}
										</tbody>
										</table> */}

										<ul className="timeline animated fadeIn">                         
											<li className="timeline-inverted">
												<div className="timeline-badge active">  <i className="fas fa-exclamation-triangle"></i> </div>
																	
												<div className="timeline-body">
												

													<div className="timeline-body">
														<div className="detailCard_Box mb-0">
														
															<div className="detailCard_Header sectionHeader">
																<h6 className="mb-0 text-muted fw-normal"> <span className="feed-item feed-item-warning "> </span> Warning <span className="text-muted"> -  {currDate}, {currTime} </span> </h6>
															</div>

															{
																warningErrorListCount>0?
																warningErrorList.map((item,ind)=>{
																	return(
																		<div className="detailCard_Body collapse show">
																			<div className="table_Box dataTables_wrapper">
																				<div className="form-group d-flex align-items-center">
																					<label className="mb-0 fw-bold text-medium"> type : </label> 
																					<span className="w-100 text-truncate  pl-1 text-muted"> "Warning" </span> 
																				</div> 
																				

																			</div> 

																			<div className="card mb-0 shadow-none">
																				<div className="card-body">
																					 <span className="text-warning pl-1"> {item.message} </span>
																				</div>
																			</div>
																		</div>
																	)	
																})												
																:
																<div className="detailCard_Body collapse show">
																	<div className="table_Box dataTables_wrapper">
																		<div className="form-group d-flex align-items-center">
																			<label className="mb-0 fw-bold text-medium"> type : </label> 
																			<span className="w-100 text-truncate  pl-1 text-muted"> "Warning" </span> 
																		</div> 
																		

																	</div> 

																	<div className="card mb-0 shadow-none">
																		<div className="card-body">
																			message: <span className="text-warning pl-1"> No Warning Message  </span>
																		</div>
																	</div>
																</div>
															}
															


														
														</div>

													</div>
												</div>
											
											</li>
										</ul>
					                </div>
					                <div className="tab-pane fade" id="msgDanger" role="tabpanel" aria-labelledby="pills-home-tab-icon">
					    				{/* <table className="table">
					    				<thead>
				                           <tr>
				                              <th scope="col">#</th> 
				                              <th scope="col"> Result </th> 
				                           </tr>
				                        </thead>
				                        <tbody>
					    				{
											errorErrorListCount>0?
											errorErrorList.map((item,ind)=>{
												return(
													<tr>
						                              <td>{ind}</td> 
						                              <td className="text-info">{item.message}</td> 
						                           </tr>
												)	
											})												
											:
											<tr>
												<td colSpan="2">
													<div className="card">
														<div className="card-header p-2">
															<div className="card-title text-default"> No Error Message </div>
														</div>	
													</div>
												</td>
											</tr>
										}
										</tbody>
										</table>					                    */}

										<ul className="timeline animated fadeIn">                         
											<li className="timeline-inverted">
												<div className="timeline-badge active">  <i className="fa fas fa-times-circle"></i> </div>
																	
													<div className="timeline-body">
													

														<div className="timeline-body">
															<div className="detailCard_Box mb-0">
															
																<div className="detailCard_Header sectionHeader">
																	<h6 className="mb-0 text-danger fw-normal"> <span className="feed-item feed-item-danger "> </span> Error <span className="text-muted"> -  {currDate}, {currTime} </span> </h6>
																</div>

																{
																	errorErrorListCount>0?
																	errorErrorList.map((item,ind)=>{
																		return (
																	
																	
																		<div className="detailCard_Body collapse show" >
																			<div className="table_Box dataTables_wrapper">
																				<div className="form-group d-flex align-items-center">
																					<label className="mb-0 fw-bold text-medium"> type : </label> 
																					<span className="w-100 text-truncate  pl-1 text-danger"> "Error" </span> 
																				</div> 
																				

																			</div> 

																			<div className="card mb-0 shadow-none">
																				<div className="card-body">
																					message: <span className="text-danger pl-1"> {item.message} </span>
																				</div>
																			</div>
																		</div>
																		)	
																	})												
																	:

																	<div className="detailCard_Body collapse show">
																		<div className="table_Box dataTables_wrapper">
																			<div className="form-group d-flex align-items-center">
																				<label className="mb-0 fw-bold text-medium"> type : </label> 
																				<span className="w-100 text-truncate  pl-1 text-danger"> "Error" </span> 
																			</div> 
																			

																		</div> 

																		<div className="card mb-0 shadow-none">
																			<div className="card-body">
																				message: <span className="text-danger pl-1"> No Error Message </span>
																			</div>
																		</div>
																	</div>

																}
																


															
															</div>

														</div>
													</div>
											
											</li>

											

											
										</ul>
					                </div>	
					    		</div>	
					    	</div>
					    	<div className="table_Footer justify-content-center">
								<a className="btn btn-cancel cursor-pointer" onClick={props.showErrorDetailsHandler}> Close </a>
							</div>
					    </div>


					    {/*
	                    <div className="table_Box dataTables_wrapper">
	                    	<div className="modal-header justify-content-center p-0">
								<ul className="nav nav-pills nav-secondary  nav-pills-no-bd" id="pills-tab-with-icon" role="tablist">
									<li className="nav-item">
										<a className="nav-link messageInfo active" data-toggle="pill" href="#msgInfo" role="tab">
											<i className="fa fa-info-circle"></i>
											Info
										</a>
									</li>
									<li className="nav-item">
										<a className="nav-link messageWarning" data-toggle="pill" href="#msgWarning" role="tab">
											<i className="fas fa-exclamation-triangle"></i>
											Warning
										</a>
									</li>
									<li className="nav-item">
										<a className="nav-link messageError" data-toggle="pill" href="#msgDanger" role="tab">
											 <i className="fa fa-times-circle"></i>
											Error
										</a>
									</li>
								</ul>
							</div>
							<div className="table_Body">
								<div className="card-body p-0">
									<div className="tab-content mt-2 mb-3" id="messageConfigBox">

										<div className="tab-pane fade show active" id="msgInfo" role="tabpanel" aria-labelledby="pills-home-tab-icon">
											{
												infoErrorList.length>0?
												infoErrorList.map((item,ind)=>{
													return(
														<div className="card">
															<div className="card-header p-2">
																<div className="card-title text-default">Information</div>
															</div>
								                            <div className="card-body p-1">
								                                <div className="d-flex justify-content-start align-items-start">
								                                   <div className="w-100" id="expressionSummary">
								                                      <div className="collapse" id={`info${ind}`}>
								                                         <div className="px-2"> 
								                                            <p className="text-info mb-0">{item.message}</p>
								                                         </div> 
								                                      </div>
								                                      <a className="collapsed" data-toggle="collapse" href={`#info${ind}`} aria-expanded="false" aria-controls="collapseSummary"></a>
								                                   </div>	                                 
								                                </div>
								                            </div>	                              
								                        </div>
													)	
												})												
												:
												<div className="card">
													<div className="card-header p-2">
														<div className="card-title text-default"> No Info Message </div>
													</div>	
												</div>
											}												
										</div>

										<div className="tab-pane fade" id="msgWarning" role="tabpanel" aria-labelledby="pills-profile-tab-icon">
											{
												warningErrorList.length>0?
												warningErrorList.map((item,ind)=>{
													return(
														<div className="card">
															<div className="card-header p-2">
																<div className="card-title text-default"> Information</div>
															</div>
								                            <div className="card-body p-1">
								                                <div className="d-flex justify-content-start align-items-start">
								                                   <div className="w-100" id="expressionSummary">
								                                      <div className="collapse" id={`warning${ind}`}>
								                                         <div className="px-2"> 
								                                            <p className="text-info mb-0">{item.message}</p>
								                                         </div> 
								                                      </div>
								                                      <a className="collapsed" data-toggle="collapse" href={`#warning${ind}`} aria-expanded="false" aria-controls="collapseSummary"></a>
								                                   </div>	                                 
								                                </div>
								                            </div>	                              
								                        </div>
													)	
												})												
												:
												<div className="card">
													<div className="card-header p-2">
														<div className="card-title text-default"> No Warning Message </div>
													</div>	
												</div>
											}											
										</div>

										<div className="tab-pane fade" id="msgDanger" role="tabpanel" aria-labelledby="pills-contact-tab-icon">
											{
												errorErrorList.length>0?
												errorErrorList.map((item,ind)=>{
													return(
														<div className="card">
															<div className="card-header p-2">
																<div className="card-title text-default"> Information</div>
															</div>
								                            <div className="card-body p-1">
								                                <div className="d-flex justify-content-start align-items-start">
								                                   <div className="w-100" id="expressionSummary">
								                                      <div className="collapse" id={`error${ind}`}>
								                                         <div className="px-2"> 
								                                            <p className="text-info mb-0">{item.message}</p>
								                                         </div> 
								                                      </div>
								                                      <a className="collapsed" data-toggle="collapse" href={`#error${ind}`} aria-expanded="false" aria-controls="collapseSummary"></a>
								                                   </div>	                                 
								                                </div>
								                            </div>	                              
								                        </div>
													)	
												})												
												:
												<div className="card">
													<div className="card-header p-2">
														<div className="card-title text-default"> No Error Message </div>
													</div>	
												</div>
											}											
										</div>

									</div>	
								</div>
							</div>
								
	                    </div>
	                	*/}

	                </div>
	            </div>
            </div>
			</>
		</Wrp>
	)
}

export default ErrorDetails;